<template>
    <div class="filemain" >
        <div class="magin">
            <el-button @click="downloadFile">下载附件</el-button>
            <el-button @click="delFile" type="danger" plain>删除附件</el-button>
        </div>
                <!-- 右上角 -->
        <VueOfficeExcel v-if="code === 'xlsx' || code === 'xls'|| code === 'xlsm'" class="file"
            :src="annexUrl" :options="{xls: true}"
            style="height: 100vh;"
            @rendered="rendered"
        />
        <VueOfficeDocx  v-else-if="code === 'docx'" class="file"
            :src="annexUrl"
            style="height: 100vh;"
            @rendered="rendered"
        />
        <VueOfficePdf  v-else-if="code === 'pdf'" class="file"
            :src="annexUrl"
            style="height: 100vh;"
            @rendered="rendered"
        />
        <div  v-else-if="code === 'png' || code === 'jpg'|| code === 'jpeg'" style="height: 100vh;" >
            <el-image   style="width: 80%;" :src="annexUrl" :fit="contain"> </el-image>
        </div>
        <div class="txt" v-else-if="code === 'txt'">{{ textContent }}</div>
        <div class="txt" v-else-if="code === 'doc'">
            doc格式文件不支持预览，请下载后查看，建议上传docx文件。
        </div>

    </div>
</template>
<script>
import VueOfficeDocx from '@vue-office/docx'
import VueOfficeExcel from '@vue-office/excel'
import VueOfficePdf from '@vue-office/pdf'
import txt from '@/utils/txt.js'
import '@vue-office/docx/lib/index.css'
import '@vue-office/excel/lib/index.css'
export default {
    components:{
        VueOfficeDocx,
        VueOfficeExcel,
        VueOfficePdf
    },
    data() {
        return {
            annexName:'', // 附件名称 
            annexUrl:'', // 附件地址
            annexUser:'', // 创建人
            id:'', // 附件id
            code:'',
            textContent:'',
        }
    },
    async created() {
        this.annexName = this.$route.query.annexName;
        this.annexUrl = this.$route.query.annexUrl;
        if(this.$route.query.annexUser){
            this.annexUser = this.$route.query.annexUser;
        }
        this.id = this.$route.query.id;
        const reversed = this.annexName.split('').reverse().join(''); // 反转字符串
        this.code = (reversed.split('.')[0]).split('').reverse().join('');
        // this.code = this.$route.query.annexName.split('.')[1];
        if(this.code === 'txt'){
            this.textContent = await txt(this.annexUrl)
        }
    },
    methods: {
        rendered() {
            console.log("渲染完成")
        },
        downloadFile(){
            let a = document.createElement("a"); // 创建a标签
            a.style.display = "none";
            a.href = this.annexUrl;
            a.setAttribute( "download", this.annexName ); // 给a标签设置download属性值，为从接口中获取到的需要下载的文件地址
            document.body.appendChild(a); // 将标签添加到页面
            a.click();
            document.body.removeChild(a);
        },
        // 删除附件
        delFile(){
            this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                if(this.annexUser){
                    if(this.annexUser === localStorage.getItem('name')){
                        this.$api.deleteFileBy( this.id ).then(res =>{
                            this.$message({
                                message: '删除成功',
                                type: 'success'
                            });
                            window.close();
                        })
                    }else{
                        this.$message({
                            message: '您没有权限删除此文件',
                            type: 'warning'
                        });
                    }
                }else{
                    this.$api.deleteAttachmentById( this.id ).then(res =>{
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        window.close();
                    })
                }
            }).catch(() => { })
        },
    }

}
</script>
<style lang="css" scoped>
.filemain{
    min-width: 500px;
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    /* align-items: center; */
}
.file{
    width: 99%;
}
.magin{
    padding-top: 10px;
    margin: 10px;
}
.txt{
    width: auto;
    padding: 0px 20px;
    height: 100vh;
    white-space: pre-wrap;
}
</style>